import $ from "jquery";
window.$ = window.jQuery = $;

require('./components/sliders');
require('./components/forms');
require('./components/countryPhoneSelector');
require('./components/uploadFile');
require('./components/main_menu');
require('./components/projectSlider');


$(document).ready(function () {
    require("jquery-lazy");
    $('.car_list_wrapper .js__tab_header').first().trigger('click');

    lazyLoad();

    //Высота шахматных элементов в портфолио
    chessHeight()
    $(window).on('resize', function() {
        chessHeight()
    })

    //Открытие подменю в футере
    footerMenuOpen()
})

function lazyLoad() {
    $("img.lazy").Lazy();
}

window.lazyLoad = lazyLoad;


//Высота шахматных элементов в портфолио
function chessHeight() {
    let items = $('.js_chess-board__image-holder')
    let width = items.eq(0).outerWidth()
    let height = width * 4 / 3
    items.each((i, el) => {
        $(el).outerHeight(height)
    })
}

//Открытие подменю в футере
function footerMenuOpen() {
    $('.js_footer__title-button').on('click', function() {
        let list = $(this).closest('.js_footer__title_hide').next('.js_footer__content_hide')
        if ($('.js_footer__title-button').not(this).hasClass('active')) {
            $('.js_footer__title-button').removeClass('active')
            $('.js_footer__content_hide').slideUp(300)
        }
        $(this).toggleClass('active')
        list.slideToggle(300)
    })

    $(window).on('resize', function() {
        if ($(document).outerWidth() > 567) {
            $('.js_footer__title-button').removeClass('active')
            $('.js_footer__content_hide').removeAttr('style')
        }
    })
}